// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__18rGG","ranges":"BmiRanges_ranges__3sCRZ"};